

export class UserTypeStatusInput implements IUserTypeStatusInput {
    /** The auto-generated id of the user type master */
    userTypeId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IUserTypeStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userTypeId = _data["userTypeId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UserTypeStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new UserTypeStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userTypeId"] = this.userTypeId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IUserTypeStatusInput {
    /** The auto-generated id of the user type master */
    userTypeId: number;
    /** The updated status */
    status: number;
}

